import { render, staticRenderFns } from "./IcCopy.vue?vue&type=template&id=d49a2958&scoped=true"
import script from "./IcCopy.vue?vue&type=script&lang=js"
export * from "./IcCopy.vue?vue&type=script&lang=js"
import style0 from "./IcCopy.vue?vue&type=style&index=0&id=d49a2958&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d49a2958",
  null
  
)

export default component.exports